var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    height: "50",
    width: "50",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-51.2 -51.2 614.40 614.40",
    stroke: "#fff"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "-51.2",
    y: "-51.2",
    width: "614.4",
    height: "614.4",
    rx: "307.2",
    fill: "#ff9800",
    stroke: "none",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.5 25.1c-9 1.8-20.8 8.3-27.7 15.2-11.2 11.2-16.3 23.5-16.3 39.7 0 16 5.1 28.5 16.1 39.4 10.9 11 23.4 16.1 39.4 16.1s28.5-5.1 39.4-16.1c11-10.9 16.1-23.4 16.1-39.4 0-11.5-1.4-17-6.8-27.2-3.5-6.7-13-16.7-19.4-20.5-11.7-6.8-28.2-9.7-40.8-7.2zM360.3 113.2l-44.2 44.2 5.2 2.9a63 63 0 0 1 7 4.5c1.7 1.5-3 6.4-76.5 79.9-43.1 43.1-77.9 78.3-77.5 78.3.4 0 6.3-1.1 13.1-2.5 20.9-4.2 37.2-5.8 61.1-5.8 12.1 0 27.4.6 34 1.2 27.6 2.7 57 8.7 73.2 15.1 4.2 1.6 7.9 2.7 8.2 2.5.2-.3.9-13.2 1.5-28.7l1.1-28.3-5.7-36.2c-7.4-47.2-9.3-52.5-23.7-67.6l-6.5-6.8 42.7-42.7c40.2-40.3 42.7-43 42.7-46.3 0-4.6-3.3-7.9-8-7.9-3.2 0-6.7 3.2-47.7 44.2zM214.5 153.5c-22.4 5-40.8 20.2-49.1 40.5-3.2 8-3.7 10.4-9.9 49.9-5.4 34.4-5.5 34.8-5.5 57.1v22.5l82.5-82.5c45.4-45.4 82.5-82.8 82.5-83.2 0-.4-3-1.7-6.7-3-6.6-2.1-8.3-2.2-47.3-2.5-31.1-.1-41.9.1-46.5 1.2zM122.8 350.8c-25.4 25.4-26.8 27-26.8 30.5 0 4.9 2.8 7.7 7.6 7.7 3.4 0 5-1.3 21.3-17.4 15.2-15 22-20.6 24.7-20.6.3 0 .4 6.9.2 15.2l-.5 15.3 14.3 52.8c7.9 29.1 14.4 53 14.4 53.3 0 .2 13.8.4 30.6.4 28.6 0 30.5-.1 30-1.8-2.3-8-17.6-89-17.2-90.8.7-2.8 8.8-7.2 18.2-10 8.1-2.5 24.7-2.5 32.8 0 9.4 2.8 17.5 7.2 18.2 10 .4 1.8-14.9 82.8-17.2 90.8-.5 1.7 1.4 1.8 30 1.8 16.8 0 30.6-.2 30.6-.5 0-.2 6.3-23.5 14.1-51.7l14.1-51.3.4-14c.3-7.7.7-15 1-16.3.5-2.3.5-2.3 3.5-.5 1.7 1 4.7 3.2 6.8 5 7.2 6.1 15.1 3.9 15.1-4.3 0-2.8-.7-4.3-3.2-6.6-5.6-5.2-17.9-12.8-20.8-12.8-.6 0-1 3.1-1 8s-.4 8-1 8-2.7-.8-4.8-1.9c-6-3-24.8-8.7-37.7-11.5-58.4-12.2-129.5-8.1-164.7 9.5l-5.7 2.9-.3-13-.3-13.1-26.7 26.9z"
  })));
});